import { useEffect, useRef } from "react";
import { getToken, onMessage } from "firebase/messaging";
import Swal from "sweetalert2";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { messaging } from "./firebase"; // Update path if needed
import axiosInstance from "./services/AxiosInstance";
import { useDispatch } from "react-redux";
import { getNotificationsAction } from "./store/actions/notification/NotificationActions";

const fpPromise = FingerprintJS.load();

const getVisitorId = async () => {
  const fp = await fpPromise;
  const result = await fp.get();
  return result.visitorId;
};

const PushNotificationHandler = ({ isAuthenticated }) => {
  const hasInitialized = useRef(false);
  const dispatch = useDispatch();

  const requestPermissionAndGetToken = async () => {
    try {
      // Check if token was already saved
      const isTokenSaved = localStorage.getItem("fcmTokenSaved");

      if (isTokenSaved === "true") {
        console.log("✅ Token already saved, skipping.");
        return;
      }

      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        console.warn("❌ Notification permission not granted.");
        return;
      }

      const token = await getToken(messaging, {
        vapidKey:
          "BLjUf48zuThCONCujmoLRFN2mdattWYzjBf55PoqdA_g60pzV6m8E1BRqOmH80taBhg1g6I879BL4TglEN4ptvs",
      });

      if (!token) {
        console.warn("⚠️ No token generated.");
        return;
      }

      const visitorId = await getVisitorId();
      console.log("✅ FCM Token:", token);
      console.log("🆔 Device Fingerprint:", visitorId);

      // Call API to save
      const data = {
        deviceSignature: visitorId,
        fcmToken: token,
      };

      try {
        const res = await axiosInstance.post("admin-device/register", data);
        console.log("📲 Token registered via API:", res.data);
        localStorage.setItem("fcmTokenSaved", "true"); // ✅ Save flag
      } catch (err) {
        console.error("❌ Failed to save token:", err);
      }
    } catch (err) {
      console.error("🔥 Error in token registration flow:", err);
    }
  };

  useEffect(() => {
    if (!isAuthenticated || hasInitialized.current) return;
    hasInitialized.current = true;

    if ("Notification" in window && "serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then(() => {
          console.log("📦 Service Worker registered");
          requestPermissionAndGetToken();
        })
        .catch((err) =>
          console.error("❌ Service Worker registration failed:", err)
        );

      onMessage(messaging, (payload) => {
        console.log("🔔 Foreground notification received:", payload);
        const title = "New Notification";
        const body = payload?.notification?.title || "You have a new message.";
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'info',
          title,
          text: body,
          showConfirmButton: true,
          timer: undefined
        });
        // Fetch latest notifications
        dispatch(getNotificationsAction(1, 10));
      });
    }
  }, [isAuthenticated, dispatch]);

  return null;
};

export default PushNotificationHandler;
